<template>
  <div>

    <router-view></router-view>
    <AppFooter v-if="isNotLoginPage"></AppFooter>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import AppFooter from './AppFooter.vue';

export default {
  components: {

    AppFooter,
  },
  setup() {
    const route = useRoute();
    const isNotLoginPage = computed(() => route.path !== '/login');

    return { isNotLoginPage };
  },
};
</script>
